import { AimsCommonPopupEditorData, AimsCommonTableHeader } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-new-trainer-qual-task-dialog',
  templateUrl: './new-trainer-qual-task-dialog.component.html',
  styleUrls: ['./new-trainer-qual-task-dialog.component.css']
})
export class NewTrainerQualTaskDialogComponent implements OnInit {

  public formGroup: any;
  qualificationTaskLookupColumns:AimsCommonTableHeader[];
  qualTaskPuValues: Observable<any>;

  constructor(contentData: AimsCommonPopupEditorData,) {
    this.formGroup = contentData.formGroup;
    this.qualTaskPuValues = contentData.contentData.qualTaskPuValues;
    this.qualificationTaskLookupColumns = contentData.contentData.qualificationTaskLookupColumns;

    this.formGroup.addControl('qualTaskId', new FormControl(null, Validators.required));
  }

  ngOnInit(): void {
  }

}
